<template>
  <div class="container">
    <div></div>
    <img
      style="width: 93px; height: 93px; display: block; margin:auto; margin-top: 50px;"
      src="@/assets/complete.png"
    />
    <h2>You're all done!</h2>
    <div style="display: flex; justify-content: center;">
      <div>
        <p>
          Income Verification: <strong>{{ incomeStatus }}</strong>
        </p>
        <p>
          Work Email Verification: <strong>{{ emailStatus }}</strong>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";

const baseUrl = process.env.VUE_APP_BACKEND_HOST;

export default {
  name: "VerificationApplicantComplete",
  computed: {
    ...mapGetters(["isApplicantLoading", "getApplicantVerification"])
  },
  data() {
    return {
      incomeStatus: "",
      emailStatus: ""
    };
  },
  async mounted() {
    try {
      const response = await axios.get(
        `${baseUrl}/api/verify/v1/verifications/`
      );

      this.incomeStatus = response.data.stage_status.income;
      this.emailStatus = response.data.stage_status.email;
    } catch (err) {
      console.log(err.response);
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  max-width: 700px;
  height: 100vh;
  margin: auto;
  padding: 30px 0px;
  h2 {
    font-size: 45px;
    line-height: 64px;
    font-weight: 400;
    text-align: center;
  }
  p {
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 34px;
    color: #545454;
    max-width: none;
  }
}
.circle {
  width: 87px;
  height: 87px;
  background: #94c959;
  border-radius: 50%;

  .triangle-block {
    height: 87px;
    display: table-cell;
    vertical-align: middle;
    .triangle {
      width: 44px;
      height: 23px;
      border: 7px solid #fff;
      box-sizing: border-box;
      border-top: none;
      border-right: none;
      margin-left: 22px;
      margin-top: -3px;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
  }
}
</style>
